import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectCurrentUser } from "../../auth/store/authSlice";
import SupportGrid from "./SupportGrid";
import SupportContactForm from "./SupportContactForm";
import PageHeader from "../../../shared/components/common/PageHeader";
import YourCases from "./YourCases";
import CreateSupportRequestModal from "./CreateSupportRequestModal";
import DeleteCaseModal from "./DeleteCaseModal";
import useSupportTickets from "../hooks/useSupportTickets";
import { isViewer } from "../../../shared/utils/roles";

const HelpAndSupport = () => {
  const navigate = useNavigate();
  const currentUser = useSelector(selectCurrentUser);
  const viewer = isViewer(currentUser?.user_role);
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [caseToDelete, setCaseToDelete] = useState(null);
  const {
    cases,
    isLoadingCases,
    isSubmittingCase,
    casesError,
    actionError,
    handleCreateNew,
    handleSubmitRequest,
    handleConfirmDelete,
  } = useSupportTickets();

  const handleCreateNewClick = () => {
    handleCreateNew();
    setShowModal(true);
  };

  const handleCloseModal = () => {
    if (isSubmittingCase) {
      return;
    }
    setShowModal(false);
  };

  const handleDeleteCase = (caseId) => {
    const caseData = cases.find((item) => item.id === caseId);
    setCaseToDelete(caseData || null);
    setShowDeleteModal(true);
  };

  const handleConfirmDeleteWrapper = async (caseId) => {
    await handleConfirmDelete(caseId);
    setShowDeleteModal(false);
    setCaseToDelete(null);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setCaseToDelete(null);
  };

  const handleCaseClick = (caseItem) => {
    if (viewer) return;
    navigate(`/support/contact-support/${caseItem.id}`);
  };

  return (
    <div>
      <PageHeader
        title="Help & Support"
        subtitle="Get help and access resources"
      />
      <SupportGrid />
      {!viewer && <SupportContactForm />}

      <div className="sm:mx-2 mt-6">
        {casesError ? (
          <div className="mb-4 rounded-md border border-danger/20 bg-danger/5 px-4 py-3 text-sm text-danger">
            {casesError}
          </div>
        ) : null}

        {actionError ? (
          <div className="mb-4 rounded-md border border-danger/20 bg-danger/5 px-4 py-3 text-sm text-danger">
            {actionError}
          </div>
        ) : null}

        {isLoadingCases ? (
          <div className="rounded-md border border-line bg-white px-4 py-6 text-sm text-muted">
            Loading support cases...
          </div>
        ) : (
          <YourCases
            cases={cases}
            onCreateNew={handleCreateNewClick}
            onCaseClick={handleCaseClick}
            onDeleteCase={handleDeleteCase}
            isViewer={viewer}
          />
        )}

        <CreateSupportRequestModal
          show={showModal}
          onClose={handleCloseModal}
          onSubmit={handleSubmitRequest}
          isSubmitting={isSubmittingCase}
        />

        <DeleteCaseModal
          show={showDeleteModal}
          onClose={handleCloseDeleteModal}
          onDelete={handleConfirmDeleteWrapper}
          caseData={caseToDelete}
        />
      </div>
    </div>
  );
};

export default HelpAndSupport;
